import { render, staticRenderFns } from "./SubSectionTableHeader.vue?vue&type=template&id=6f074663"
import script from "./SubSectionTableHeader.vue?vue&type=script&lang=js"
export * from "./SubSectionTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports